var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.5,
    height: 9.789807319641113,
    viewBox: "0 0 13.5 9.789807319641113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.0077,0.255249L4.58508,7.67782L1.49234,4.58596C1.15289,4.24563,0.595582,4.24563,0.255249,4.58596C-0.0850831,4.92629,-0.0850831,5.48272,0.255249,5.82305L3.96129,9.52909C3.96304,9.53084,3.96391,9.53259,3.96566,9.53434C4.13539,9.70494,4.36024,9.78981,4.58508,9.78981C4.80993,9.78981,5.0339,9.70494,5.20451,9.53434C5.20626,9.53259,5.20713,9.53084,5.20888,9.52909L13.2448,1.49234C13.5851,1.15201,13.5851,0.595582,13.2448,0.255249C12.9044,-0.0850831,12.348,-0.0850831,12.0077,0.255249Z",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.404e497d9b56f546a87bb9aefa089677.svg";
export { ForwardRef as ReactComponent };